export default __webpack_public_path__ + "static/media/A7.d7be2d2e.jpg";